export default __webpack_public_path__ + "static/Verwaltung-3d2460b946dd57c2a136c8e309e8849d.png";